export enum LoginStatus {
  evaluating,
  loggedIn,
  loggedOut,
}
